import type { ReactNode } from 'react';
import { IconStore } from '@7shifts/sous-chef-base';
import { useTerminalAccount } from '@src/context/AccountContext';
import { useCurrentTime } from './useCurrentTime';
import './LocationInfo.css';

const TIME_FORMAT = new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
});

const DATE_FORMAT = new Intl.DateTimeFormat(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
});

interface LocationInfoProps {
    /**
     * Optional content rendered below the clock/date block — used to show the
     * offline warning banner (API-4380) as part of the centered left-panel
     * group.
     */
    children?: ReactNode;
}

export function LocationInfo({ children }: LocationInfoProps) {
    const { account } = useTerminalAccount();
    const now = useCurrentTime();

    if (!account) return null;

    return (
        <div className="location-info">
            <div className="location-info__header">
                <div className="location-info__avatar">
                    {account.logoUrl ? (
                        <img
                            src={account.logoUrl}
                            alt=""
                            className="location-info__avatar-img"
                        />
                    ) : (
                        <IconStore aria-hidden />
                    )}
                </div>
                <div className="location-info__title">
                    <span className="location-info__company">
                        {account.companyName}
                    </span>
                    <span className="location-info__location">
                        {account.locationName}
                    </span>
                </div>
            </div>
            <div className="location-info__time-block">
                <span className="location-info__time">
                    {TIME_FORMAT.format(now)}
                </span>
                <span className="location-info__date">
                    {DATE_FORMAT.format(now)}
                </span>
            </div>
            {children}
        </div>
    );
}
